import '../../vendor/flickity.pkgd.min.js';

/**
 * Initialize Flickity Slider for Slider-features
 *
 * @param {}
 * @return {void}
 */

export const initializeSliderFeatures = (slider = '.js-slider-features') => {
  let group = 2;

  if ($(window).outerWidth() > 767) {
    group = 3;
  }

  const config = {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    groupCells: true,
    freeScroll: true,
    wrapAround: false,
    groupCells: group,
    cellSelector: '.slider__slide'
  };

  $(slider)
    .not('.flickity-enabled')
    .flickity(config);
};

$(window).on('load', function(event) {
  initializeSliderFeatures();
});
